<script setup lang="ts">
import CopyButton from '@/components/common/CopyButton.vue'
import { lastNChars } from '@/helpers/index.ts'
import { DEFAULT_MINER_SN_THRESHOLD } from '@/config/rcapp.config'
import { Icon } from '@iconify/vue'
import { computed } from 'vue'

const recurrencyMessage = computed(() => `This ${props.type} has already been recorded in the RC`)

const props = withDefaults(
  defineProps<{ sn: string; threshold?: number; recurrent?: boolean; type?: 'miner' | 'part' }>(),
  {
    threshold: DEFAULT_MINER_SN_THRESHOLD,
    recurrent: false,
    type: 'miner',
  }
)
</script>

<template>
  <!-- Large SN, truncate and wrap in tooltip -->
  <span class="text-nowrap">
    <el-tooltip :content="sn" :disabled="sn.length <= threshold">
      <template #content
        ><copy-button :value="sn">{{ sn }}</copy-button>
      </template>
      <span> {{ lastNChars(sn, threshold - 3) }}</span>
    </el-tooltip>
    <!-- Recurrency tooltip -->
    <el-tooltip v-if="recurrent" :content="recurrencyMessage" placement="top"
      ><Icon class="inline color-text-component-label" :height="20" icon="material-symbols:reset-wrench"
    /></el-tooltip>
  </span>
</template>
